import { Transition360 } from '@/features/Transition360/Transition360';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/transition-360/')({
    component: Transition360,
});
